<div class="container">
  <mat-toolbar color="primary" class="custom-header">
    <button mat-icon-button (click)="closeModal()">
      <mat-icon svgIcon="mat:chevron_left"></mat-icon>
    </button>
  </mat-toolbar>

  <h2>{{exercise.exerciseName[translate.currentLang.toUpperCase()]}}</h2>
  <img [src]="environment.exercises+'/'+exercise.exerciseId+'/images/main'">

  <div class="box" *ngFor="let item of exercise.datas">
    <span>
      <p class="workout-name">{{item.i18nNameWorkout ? item.i18nNameWorkout[translate.currentLang.toUpperCase()] : null}}</p>
      <p class="phase-name">{{item.phaseName ? item.phaseName[translate.currentLang.toUpperCase()] : null}}</p>

      <p *ngIf="item.sets" class="sets">
        {{item.sets}} {{"WORKOUT.WORKOUT-EXE.SET"|translate}} |
        <span *ngIf="item.seconds > 0">
          {{item.seconds < 60 ? item.seconds : convertToMMSS(item.seconds)}}
          <span *ngIf="item.seconds < 60" class="left-px">{{"WORKOUT.WORKOUT-DETAIL.SECS" | translate}}</span>
          <span *ngIf="item.seconds === 60" class="left-px">{{"WORKOUT.WORKOUT-DETAIL.MIN" | translate}}</span>
          <span *ngIf="item.seconds > 60" class="left-px">{{"WORKOUT.WORKOUT-DETAIL.MINS" | translate}}</span>
        </span>
        <span *ngIf="item.reps > 0"> {{item.reps}} {{"WORKOUT.WORKOUT-DETAIL.REPS" | translate}}</span>
      </p>

      <p *ngIf="!item.sets">
        <span *ngIf="item.seconds > 0">
          {{item.seconds < 60 ? item.seconds : convertToMMSS(item.seconds)}}
          <span *ngIf="item.seconds < 60" class="left-px">{{"WORKOUT.WORKOUT-DETAIL.SECS" | translate}}</span>
          <span *ngIf="item.seconds === 60" class="left-px">{{"WORKOUT.WORKOUT-DETAIL.MIN" | translate}}</span>
          <span *ngIf="item.seconds > 60" class="left-px">{{"WORKOUT.WORKOUT-DETAIL.MINS" | translate}}</span>
        </span>
        <span *ngIf="item.reps > 0"> {{item.reps}} {{"WORKOUT.WORKOUT-DETAIL.REPS" | translate}}</span>
      </p>
    </span>

    <span>
      <p class="date">{{item.registerDate | date: guiService.dateFormat}}</p>
      <p class="weight">{{item.weight}} {{item.unit}}</p>
    </span>
  </div>
</div>
